import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LegView } from '@sequence/models/view/leg.view';
import { SharedModule } from '@shared/modules/shared.module';
import { InboundConnectionsComponent } from './inbound-connections/inbound-connections.component';
import { OutboundConnectionsComponent } from './outbound-connections/outbound-connections.component';

@Component({
  selector: 'app-pax-connections',
  templateUrl: './pax-connections.component.html',
  styleUrl: './pax-connections.component.scss',
  standalone: true,
  imports: [
    SharedModule,
    InboundConnectionsComponent,
    OutboundConnectionsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaxConnectionsComponent {
  @Input() flightState?: LegView;
}
